export default __webpack_public_path__ + "static/media/qr-ht-mipt.fc0592f8.png";